
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const ms151r = {
    label: "Retire Director",
    pageLabel: "Retire Director",
    starting: true,
    url: "ms151r",
    pageType: "history",
    formTabs: {
        allTabs: [
            { label: "Filter Options", uid: "filterop", style: { fontFamily: "verdana" } },
        ]
    } ,    
    form: [
        {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Director Type",
            name: "",
            description: "Enter Director Type"
          },
          {
            inputType: "select",
            tab: "filterop",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Chairman",
                value: "Chairman"
              },
              {
                label: "Vice Chairman",
                value: "ViceChairman"
              },
              {
                label: "Director",
                value: "Director"
              },
              {
                label: "Advisory Director",
                value: "AdvisoryDirector"
              },
              {
                label: "Expert Director",
                value: "ExpertDirector"
              },
              {
                label: "Staff Director",
                value: "StaffDirector"
              },
             ],
            placeHolder: "Director Type",
            name: "Directory_Type",
            description: "Enter Directory Type"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Search",
            name: "",
            description: "Enter Search"
          },
          {
            inputType: "text",
            tab: "filterop",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Search",
            name: "Search",
            description: "Enter Search"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Customer No",
            name: "",
            description: "Enter Customer No" 
          },
          {
            inputType: "autocomplete",
            tab: "filterop",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Customer No",
            name: "CustomerNo",
            description: "Customer No"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "As On Date",
            name: "",
            description: "Enter As On Date"
          },
          {
            inputType: "date",
            dateType: "ontype",
            tab: "filterop",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "As On Date",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "AsOnDate",
            description: "Enter As On Date"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Retire Date",
            name: "",
            description: "Enter Retire Date"
          },
          {
            inputType: "date",
            dateType: "ontype",
            tab: "filterop",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "RetireDate",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "RetireDate",
            description: "Enter Retire Date"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Number of Records",
            name: "",
            description: "Enter Number of Records"
          },
          {
            inputType: "text",
            tab: "filterop",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Number of Records",
            name: "NumberofRecords",
            description: "Enter Number of Records"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            tab: "filterop",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Active",
            name: "active",
            description: "Active"
          },
          
    ]
}

export default ms151r;